/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Video16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M13.999 4a1 1 0 011 1v8c0 .555-.446 1-1 1h-10a.998.998 0 01-.998-1V5a1 1 0 01.998-1h10zm0 1h-10l.002 8h9.998V5zM8.525 2a.477.477 0 010 .953l-5.539.042a.996.996 0 00-.992.993l-.043 6.54a.477.477 0 01-.476.472.474.474 0 01-.475-.472V4a2 2 0 012-2h5.525zm-.684 5c.13 0 .259.03.375.089l2.32 1.16a.84.84 0 010 1.502l-2.32 1.16A.84.84 0 017 10.162V7.84A.84.84 0 017.841 7zm0 .84v2.32L10.161 9l-2.32-1.16z"
        />
    </AccessibleSVG>
);

export default Video16;
